import { Component } from '@angular/core';

@Component({
    selector: 'app-config-error-page',
    template: `
    <div class="d-flex align-items-center justify-content-center vw-100 vh-100 bg-gradient bg-dark p-5">
      <div class="d-flex flex-column align-items-center text-danger text-center">
        <span class="material-icons icon-large">error_outline</span>
        <span class="fs-2" i18n>Anwendungskonfiguration fehlt</span>
      </div>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }

    .icon-large {
      font-size: 8rem;
    }
  `],
    standalone: false
})
export class AppConfigErrorPage {
}
